import { types } from './agendamentoRelatorio.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

// A projecao da listagem e fixa no back (AgendamentoRelatorioService.CAMPOS_LISTAGEM): as colunas calculadas
// (proxima execucao, ultimo status) nao sao campos da entidade.
const initialState = {
  id: 'agendamentorelatorio',
  selectedFilters: [],
  showHideColumns: [
    { label: 'Código', value: { field: 'oid', visible: true } },
    { label: 'Descrição', value: { field: 'descricao', visible: true } },
  ],
  columns: [],
  currentRecord: {},
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDAgendamentoRelatorioReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('agendamentorelatorio')
  }
  return reducer.execute(state, action)
}
